export default __webpack_public_path__ + "static/media/blue_light_subscription.e6fe1eb4.svg";